var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clocking out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12,4.49H2.88a.61.61,0,0,0-.61.62v9.23a.61.61,0,0,0,.61.62h9.24a.61.61,0,0,0,.61-.62V5.11A.61.61,0,0,0,12.12,4.49ZM7.5,13.73a4,4,0,1,1,4-4A4,4,0,0,1,7.5,13.73Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.97,
    r: 0.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.56,
    r: 0.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.71,
    cy: 9.77,
    r: 0.34
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.29,
    cy: 9.94,
    r: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69,9.79v.15a.15.15,0,0,1-.15.15H7.28V7.37a.16.16,0,0,1,.16-.15h.15a.15.15,0,0,1,.15.15V9.63h1.8A.15.15,0,0,1,9.69,9.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45,0a.91.91,0,0,1-1,.84.89.89,0,0,1-1-.84H5.4v4.2H9.59V0ZM6.34,3.42l1.15-2,1.16,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockout);
export default __webpack_public_path__ + "static/media/clockout.a9e51701aca6744aa2db8d65ae3108cc.svg";
export { ForwardRef as ReactComponent };